import { isTrucknetDomain, TRUCKNET_DOMAIN } from "./trucknetDomain";

export const getCookieByName = (name) => {
  const matches = document.cookie.match(
    new RegExp(
      `(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1")}=([^;]*)`,
    ),
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
};

export const setAccessTokenToCookies = (token) => {
  if (!token) {
    return;
  }

  const domain = isTrucknetDomain() ? TRUCKNET_DOMAIN : "";
  document.cookie = `trucknet_access_token=${token};${
    domain ? `domain=${domain}` : ""
  }`;
};

export const clearAccessTokenFromCookies = () => {
  const domain = isTrucknetDomain() ? TRUCKNET_DOMAIN : "";

  document.cookie = `trucknet_access_token=0; max-age=-1;${
    domain ? `domain=${domain}` : ""
  }`;
};

export const getAccessTokenFromCookies = () =>
  getCookieByName("trucknet_access_token");



// WEBPACK FOOTER //
// ./src/cookies.js